import { useSelector } from 'react-redux';
import { selectIsSamlUser, selectIsLdapUser } from '@ovpn-ui-toolkit/mf-common';
import {
    routes,
    redirectToSSO,
    selectIsOwner,
    selectFrieldlyRole,
    BillingEvents,
} from '@cloud/shared';

import { ProfileMenu } from '@ovpn-ui/navigation';

import { useAppDispatch } from '../../../store';

const billingSubscriptionsUrl = '/billing/subscriptions' as const;
const billingEditSubscriptionUrl = '/billing/subscriptions/current/edit?action=upgrade' as const;

function useUserMenuItems() {
    const dispatch = useAppDispatch();
    const isSaml = useSelector(selectIsSamlUser);
    const isLdap = useSelector(selectIsLdapUser);

    const isOwner = useSelector(selectIsOwner);
    const friendlyRole = useSelector(selectFrieldlyRole);
    const showProfileLink = !((isSaml || isLdap) && !isOwner);

    return {
        role: {
            name: 'Role',
            value: friendlyRole,
        },

        logout: {
            href: redirectToSSO(window.location.origin, 'logout'),
            id: 'account-menu-logout',
        },

        links: [
            showProfileLink && {
                name: 'My Account',
                id: 'account-menu-profile',
                to: routes.ssoAccount,
            },
            isOwner && {
                name: 'Edit Subscription',
                id: 'account-menu-subscription',
                onNavigate: () =>
                    dispatch(
                        BillingEvents.openBillingModal({
                            actionSource: 'EDIT_SUBSCRIPTION',
                            fallbackRedirectUrl: billingEditSubscriptionUrl,
                        }),
                    ),
            },
            isOwner && {
                name: 'My Subscriptions',
                id: 'account-menu-my-subscriptions',
                onNavigate: () =>
                    dispatch(
                        BillingEvents.openBillingModal({
                            actionSource: 'MY_SUBSCRIPTIONS',
                            fallbackRedirectUrl: billingSubscriptionsUrl,
                        }),
                    ),
            },
        ].filter(Boolean) as React.ComponentProps<typeof ProfileMenu>['links'],
    };
}

export default useUserMenuItems;
